// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"94f931b5","79":"80e0ecd8","787":"6df47463","941":"c6d6b8da","996":"86e06314"}[chunkId] + ".chunk.js";
};